import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorInstancesQuery,
  GetProcessorInstancesQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSOR_INSTANCES: TypedDocumentNode<
  GetProcessorInstancesQuery,
  GetProcessorInstancesQueryVariables
> = gql`
  query GetProcessorInstances($limit: Int) {
    processorInstances(limit: $limit) {
      id
      processorId
      userId
      status
      metadata
      error
      createdAt
      updatedAt
    }
  }
`;
